import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

// services
import { TranslateService } from '@ngx-translate/core';

// types
import {
  ProfileCollectionFacade,
  ProfileCollectionViewModel,
  SortKey,
} from '@app/profile/components/profile-collection/profile-collection-reactive-store';

@Component({
  selector: 'dgx-profile-collection-sorting',
  templateUrl: './profile-collection-sorting.component.html',
  styleUrls: ['./profile-collection-sorting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileCollectionSortingComponent implements OnInit {
  public vm$: Observable<ProfileCollectionViewModel>;

  public i18n = this.translateService.instant(['Core_SortBy']);

  constructor(
    private translateService: TranslateService,
    private profileCollectionFacade: ProfileCollectionFacade
  ) {}

  public ngOnInit(): void {
    this.vm$ = this.profileCollectionFacade.vm$;
  }

  public setSortKey(sortKey: SortKey): void {
    this.profileCollectionFacade.setSortKey(sortKey);
  }
}
